import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Column } from 'react-base-table';

import { fetchData } from '@store/errorLogicConfig/configData/actions';
import { setConfigSorting } from '@store/errorLogicConfig/base/actions';
import { configDataSortSelector, loadingSelector } from '@store/errorLogicConfig/configData/selectors';
import { Retry } from '@components/common';

import Summary from '../Common/Summary';
import { ContentWrapper, DataTableWrapper } from '../styled';
import { DataColumns, getRowCalss } from './utils';
import KebabColumn from './KebabColumn';
import WarningModal from './WarningModal';

import Table from '@components/common/Table';

function ConfigTable() {
  const dispatch = useDispatch();

  const { data, sort } = useSelector(configDataSortSelector);
  const { loading, showError } = useSelector(loadingSelector);

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  const onColumnSort = ({ key, order }) => {
    dispatch(setConfigSorting({ key, order }));
  }

  const menuColumn = {
    title: '',
    dataKey: '',
    key: 'action',
    width: 50,
    frozen: Column.FrozenDirection.RIGHT,
    cellRenderer: ({ rowData }) => (
      <KebabColumn rowData={rowData} />
    ),
  };

  const retryAction = () => dispatch(fetchData());

  const ColumnRenderer = [...DataColumns, menuColumn];
  return (
    <ContentWrapper>
      <Summary />
      <WarningModal />
      <DataTableWrapper>
        <Retry
          isLoading={loading}
          showError={showError}
          fetchData={retryAction}
        >
          <Table
            fixed
            data={data}
            columns={ColumnRenderer}
            onColumnSort={onColumnSort}
            rowClassName={getRowCalss}
            sortBy={sort}
          />
        </Retry>
      </DataTableWrapper>
    </ContentWrapper>
  );
}

export default ConfigTable;
